import PromotedStatus from './promoted_status';

export default PromotedStatus;
